import { Dialog, Button } from '@mui/material';
import React, { useState, useEffect, forwardRef, Ref, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { CodedEntry } from '../../../../../shared/utils/bodyPart';
import { BodyPartSelector } from '../../../features/UploadImages/BodyPartSelector';
import { slotInputStyle } from '../../styledComponentStyle';

import { SlotWrapper, SlotWrapperProps } from './SlotWrapper';
import { useEnrollSlotRef } from './hooks';
import { SlotRef } from './types';

const StyledButton = styled.button<{ $fullWidth?: boolean }>`
  ${slotInputStyle};
  background-color: transparent;
  padding-top: 5px;
  padding-bottom: 5px;
  border: 1px solid var(--Hscan_light_grey, #e7e7e7);
  border-radius: 4px;
  color: var(--Hscan_text_light_grey, #a3a6ab);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
`;

interface BodyPartPickerSlotProps extends SlotWrapperProps {
  selected?: CodedEntry;
  onSelected: (loc: CodedEntry | undefined) => void;
}
export const BodyPartPickerSlot = forwardRef(
  (
    { selected, onSelected, ...slotWrapperProps }: BodyPartPickerSlotProps,
    ref: Ref<SlotRef>,
  ) => {
    const wrapperRef = useRef(null);
    useEnrollSlotRef({ ref, wrapperRef, inputs: [] });

    const { t } = useTranslation();

    const [locationCode, setLocationCode] = useState<CodedEntry>();
    const [injuryModal, setInjuryModal] = useState(false);

    const onClickSelect = () => {
      locationCode && onSelected(locationCode);
      setInjuryModal(false);
    };

    useEffect(() => {
      setLocationCode(undefined);
    }, [injuryModal]);

    return (
      <SlotWrapper ref={wrapperRef} {...slotWrapperProps}>
        <StyledButton onClick={() => setInjuryModal(true)}>
          {selected
            ? t(`common.bodyPart.${selected?.meaning}`)
            : t('features.uploadImages.slots.bodypart.placeholder')}
        </StyledButton>
        <Dialog onClose={() => setInjuryModal(false)} open={injuryModal}>
          <BodyPartSelector code={locationCode} setCode={setLocationCode} />
          <Button size="large" disabled={!locationCode} onClick={onClickSelect}>
            {!!locationCode && t(`common.bodyPart.${locationCode.meaning}`)}{' '}
            {t('common.button.select')}
          </Button>
        </Dialog>
      </SlotWrapper>
    );
  },
);
